import { InsurancePolicy, IServiceResponse } from '@/interfaces';
import { RequestServices as _http } from '../common/request.services';
import {
  deferPaymentApplyBusinessRules,
  deferPaymentGetMaxDeferPaymentDays,
  deferPaymentGetPaymentInstrument,
  deferPaymentGetPolicy,
} from '@/constants/forms-api.const';
import {
  ApplyRulesRequestOfDeferPaymentUpdateModel,
  ApplyRulesResponseOfDeferPaymentViewModel,
  IMaxDeferPaymentDaysResponse,
  IMaxDeferPaymentRequest,
  IPaymentInstrument,
} from '@/interfaces/self-service/defer-payment.interface';

export const DeferAPaymentService = {
  /**
   * Get Policy
   *
   * @param quoteSessionId
   */
  getPolicy(quoteSessionId: string): Promise<IServiceResponse<InsurancePolicy>> {
    return _http.HttpGet(deferPaymentGetPolicy.replace('{0}', quoteSessionId));
  },

  /**
   * Apply Business Rules
   *
   * @param request
   */
  applyBusinessRules(
    request: ApplyRulesRequestOfDeferPaymentUpdateModel
  ): Promise<IServiceResponse<ApplyRulesResponseOfDeferPaymentViewModel>> {
    return _http.HttpPost(deferPaymentApplyBusinessRules, request);
  },

  getMaxDeferDays(request: IMaxDeferPaymentRequest): Promise<IMaxDeferPaymentDaysResponse> {
    return _http.HttpPost(deferPaymentGetMaxDeferPaymentDays, request);
  },

  /**
   * Get payment instrument
   * @param quoteSessionId
   * @returns
   */
  getPaymentInstrument(quoteSessionId: string): Promise<IPaymentInstrument> {
    return _http.HttpGet(deferPaymentGetPaymentInstrument.replace('{0}', quoteSessionId));
  },
};
